import { render, staticRenderFns } from "./jaw-header-placeholder.vue?vue&type=template&id=6f94351a&"
import script from "./jaw-header-placeholder.vue?vue&type=script&lang=js&"
export * from "./jaw-header-placeholder.vue?vue&type=script&lang=js&"
import style0 from "./jaw-header-placeholder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports